import {
	GuarantorEntityType,
	PatientEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PdfLetterhead } from "../pdf-template-components/pdf-letterhead.component";
import { PdfLayout } from "../pdf-template-components/pdf-layout.component";
import { PdfRecipientAddress } from "../pdf-template-components/pdf-recipient-address.component";
import { QrPaymentSlip } from "../pdf-template-components/qr-payment-slip/qr-payment-slip.component";
import { PaymentSlipDataInput } from "../pdf-template-components/qr-payment-slip/qr-payment-helpers";
import "../fonts.css";
import { PdfTemplateType } from "../document-template.types";
import { PdfInvoiceBody } from "../pdf-template-components/pdf-invoice-body.component";
import { CommonPDFTemplateProps } from "./types";
import { PdfFooter } from "../pdf-template-components/pdf-footer.component";

export interface RechnungTemplateProps extends CommonPDFTemplateProps {
	patient?: PatientEntityType;
	guarantor?: GuarantorEntityType;
	paymentSlipData: PaymentSlipDataInput;
}

export const RechnungTemplate: React.FC<RechnungTemplateProps> = ({
	client,
	job,
	jobDocument,
	jobItems,
	organization,
	pdfTemplateConfiguration,
	patient,
	guarantor,
	paymentSlipData,
	jobTotals,
}) => {
	if (
		!organization ||
		!pdfTemplateConfiguration ||
		!job ||
		!jobDocument ||
		!jobItems ||
		!client ||
		!paymentSlipData
	) {
		return null;
	}
	return (
		<PdfLayout pdfTemplateConfiguration={pdfTemplateConfiguration}>
			<PdfLetterhead
				organization={organization}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				pdfType={PdfTemplateType.RECHNUNG}
			/>
			<PdfRecipientAddress
				recipient={job.guarantor_id && guarantor ? guarantor : client}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				template={PdfTemplateType.RECHNUNG}
			/>
			<PdfInvoiceBody
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				title="Rechnung"
				client={client}
				job={job}
				jobDocument={jobDocument}
				jobItems={jobItems}
				patient={patient}
				paymentSlipData={paymentSlipData}
				organization={organization}
				jobTotals={jobTotals}
			/>
			<PdfFooter
				templateType={PdfTemplateType.RECHNUNG}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
			/>
			<QrPaymentSlip
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				paymentSlipData={paymentSlipData}
				textAbove={
					pdfTemplateConfiguration[PdfTemplateType.RECHNUNG]
						.textAbovePaymentSlip
				}
			/>
		</PdfLayout>
	);
};
